import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import { useParams, Link, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  DATA_EXPORT,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Box } from "@mui/material";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import { toastWarn } from "../../../common/Toast";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const SalesbyProductServiceSummary = (props) => {
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const navigate = useNavigate();
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    currencySymbolLocation,
    ReportViewPermission,
  } = useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [columnby, setcolumnby] = useState([]);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [columnsByOptions, setColumnsByOptions] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [selectedColumnsBy, setSelectedColumnBy] = useState(1);
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [selectedlocationid, setSelectedLocationID] = useState(
    Number(locationid)
  );

  const [classicView, setClassicView] = useState(true);

  console.log(selectedColumnsBy, "selectedColumnsBycheck");

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const locationDropdownOption = [
    { label: "All", value: 0 }, // Adding "All" option
    ...locationdropdown.map((u) => ({ label: u.Name, value: u.Id })),
  ];

  const handleDropdownChange = (event) => {
    // const selectedValue = event.target.value;
    setSelectReport(event?.value);
    console.log(event.target.value);
  };
  const handleLocationDropdownChange = (event) => {
    setSelectedLocationID(event?.value);
    console.log(event?.value, "Location chnage");
  };

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/salesbyproductsummary?startdate=${startdate}&enddate=${enddate}&columnby=${selectedColumnsBy}&locationid=${selectedlocationid}&currentlocationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          if (res.data.ResponseData.length > 0) {
            const numArr = res.data.ResponseData.map((obj) => {
              return {
                ...obj,
                Amount: obj.Amount ? Number(obj.Amount) : 0,
                PercentOfSale: obj.PercentOfSale
                  ? Number(obj.PercentOfSale)
                  : 0,
                AvgPrice: obj.AvgPrice ? Number(obj.AvgPrice) : 0,
                COGS: obj.COGS ? Number(obj.COGS) : 0,
                GrossMargin: obj.GrossMargin ? Number(obj.GrossMargin) : 0,
                GrossMarginPercent: obj.GrossMarginPercent
                  ? Number(obj.GrossMarginPercent)
                  : 0,
              };
            });
            setResponseData(numArr);
          } else {
            toastWarn("No Records Found!");
          }
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   apicall();
  // }, [startdate, enddate]);

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.reportsBaseUrl}/reports/getcolumnsbyoptions`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const filtered = res.data.ResponseData.map(
          (u, i) => (reportdropdown[i] = { label: u.Name, value: u.Id })
        );
        setColumnsByOptions(filtered);
        return res;
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    // axios
    //   .get(`${config.reportsBaseUrl}/reports/reportsbindingdropdown`, {
    //     headers: {
    //       "Content-Type": "application/json;charset=UTF-8",
    //       Authorization: token,
    //     },
    //   })
    //   .then((res) => {
    //     console.log("column======>", res);
    //     setcolumnby(res.data.ResponseData);
    //     // setLoading(false);
    //     return res;
    //   });
  }, []);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Product/Service",
      accessorKey: "Itemname",
      filterFn: "contains",
      size: "110",
      // Footer: () => <Box>TOTAL</Box>,
    },
    {
      header: "Quantity",
      accessorKey: "Quantity",
      filterFn: "contains",
      size: "110",
      Footer: ({ table }) => {
        // Calculate the total for the column
        const totalQty = table.getRowModel().rows.reduce((sum, row) => {
          const qty = parseFloat(row.original?.Quantity || 0);
          return sum + (isNaN(qty) ? 0 : qty);
        }, 0);
        const formattedTotal = totalQty;
        // typeof totalQty === "number"
        // ? CurrencySymbols(
        //   Number(totalQty).toFixed(FractionDigits),
        //   { CurrencySymbol },
        //   FractionDigits
        // )
        // : "N/A";

        return (
          <Box sx={{ textAlign: "right", fontWeight: "bold", padding: "8px" }}>
            Total: {formattedTotal}
          </Box>
        );
      },
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => {
        const amount = row?.original?.Amount;
        if (amount == "0.00" || amount == "") {
          return "";
        } else {
          return (
            <Link
              style={{
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight: "600",
                p: "0.3rem",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              type="button"
              onClick={() =>
                navigate(
                  `/sales-by-product-service-detail?itemid=${row.original.ItemId}&startdate=${startdate}&enddate=${enddate}`
                )
              }
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
            >
              {CurrencySymbols(
                Number(amount),
                { CurrencySymbol },
                FractionDigits
              )}
            </Link>
          );
        }
      },
      AggregatedCell: ({ cell, row }) => {
        const aggregatedValue = cell.getValue();
        const isItemName = row.depth === 0; // Adjust based on your table's grouping structure

        const formattedValue =
          typeof aggregatedValue === "number" && isItemName
            ? CurrencySymbols(
                Number(aggregatedValue),
                { CurrencySymbol },
                FractionDigits
              )
            : "";

        return isItemName ? (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total :
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {formattedValue}
            </Box>
          </>
        ) : null;
      },

      // AggregatedCell: ({ cell, table }) => {

      //   // Retrieve the aggregated value
      //   const aggregatedValue = cell.getValue();

      //   // Check if the value is valid and format it
      //   const formattedValue =
      //     typeof aggregatedValue === "number"
      //       ? CurrencySymbols(
      //           Number(aggregatedValue),
      //           { CurrencySymbol },
      //           FractionDigits
      //         )
      //       : "N/A";

      //   return (
      //     <>
      //       <Box component="span" sx={{ fontWeight: "bold" }}>
      //         Total :
      //       </Box>{" "}
      //       <Box
      //         sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
      //       >
      //         {formattedValue}
      //       </Box>
      //     </>
      //   );
      // },
      Footer: ({ table }) => {
        // Calculate the total for the column
        const totalAmount = table.getRowModel().rows.reduce((sum, row) => {
          const amount = parseFloat(row.original?.Amount || 0);
          return sum + (isNaN(amount) ? 0 : amount);
        }, 0);
        const formattedTotal =
          typeof totalAmount === "number"
            ? CurrencySymbols(
                Number(totalAmount).toFixed(FractionDigits),
                { CurrencySymbol },
                FractionDigits
              )
            : "N/A";

        return (
          <Box sx={{ textAlign: "right", fontWeight: "bold", padding: "8px" }}>
            Total: {formattedTotal}
          </Box>
        );
      },
    },
    {
      header: "% of Sale",
      accessorKey: "PercentOfSale",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => Number(row.original.PercentOfSale).toFixed(2),
      AggregatedCell: ({ cell, row }) => {
        const aggregatedValue = cell.getValue();
        const isItemName = row.depth === 0; // Adjust based on your table's grouping structure

        const formattedValue =
          typeof aggregatedValue === "number" && isItemName
            ? Number(aggregatedValue).toFixed(2)
            : "";

        return isItemName ? (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total :
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {formattedValue}
            </Box>
          </>
        ) : null;
      },
      Footer: ({ table }) => {
        // Calculate the total for the column
        const totalAmount = table.getRowModel().rows.reduce((sum, row) => {
          const amount = parseFloat(row.original?.PercentOfSale || 0);
          return sum + (isNaN(amount) ? 0 : amount);
        }, 0);
        const formattedTotal =
          typeof totalAmount === "number"
            ? Number(totalAmount).toFixed(FractionDigits)
            : "N/A";
        return (
          <Box sx={{ textAlign: "right", fontWeight: "bold", padding: "8px" }}>
            Total: {formattedTotal}%
          </Box>
        );
      },
    },
    {
      header: "AVG Price",
      accessorKey: "AvgPrice",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => {
        const avgPrice = row?.original?.AvgPrice;
        if (avgPrice == "0.00" || avgPrice == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(avgPrice),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
      AggregatedCell: ({ cell, row }) => {
        const aggregatedValue = cell.getValue();
        const isItemName = row.depth === 0; // Adjust based on your table's grouping structure

        const formattedValue =
          typeof aggregatedValue === "number" && isItemName
            ? CurrencySymbols(
                Number(aggregatedValue),
                { CurrencySymbol },
                FractionDigits
              )
            : "";

        return isItemName ? (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total :
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {formattedValue}
            </Box>
          </>
        ) : null;
      },
      Footer: ({ table }) => {
        // Calculate the total for the column
        const totalAmount = table.getRowModel().rows.reduce((sum, row) => {
          const amount = parseFloat(row.original?.AvgPrice || 0);
          return sum + (isNaN(amount) ? 0 : amount);
        }, 0);
        const formattedTotal =
          typeof totalAmount === "number"
            ? CurrencySymbols(
                Number(totalAmount).toFixed(FractionDigits),
                { CurrencySymbol },
                FractionDigits
              )
            : "N/A";

        return (
          <Box sx={{ textAlign: "right", fontWeight: "bold", padding: "8px" }}>
            Total: {formattedTotal}
          </Box>
        );
      },
    },
    {
      header: "COGS",
      accessorKey: "COGS",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => {
        const cogs = row?.original?.COGS;
        if (cogs == "0.00" || cogs == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(cogs),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
      AggregatedCell: ({ cell, row }) => {
        const aggregatedValue = cell.getValue();
        const isItemName = row.depth === 0; // Adjust based on your table's grouping structure

        const formattedValue =
          typeof aggregatedValue === "number" && isItemName
            ? CurrencySymbols(
                Number(aggregatedValue),
                { CurrencySymbol },
                FractionDigits
              )
            : "";

        return isItemName ? (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total :
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {formattedValue}
            </Box>
          </>
        ) : null;
      },
      Footer: ({ table }) => {
        // Calculate the total for the column
        const totalAmount = table.getRowModel().rows.reduce((sum, row) => {
          const amount = parseFloat(row.original?.COGS || 0);
          return sum + (isNaN(amount) ? 0 : amount);
        }, 0);
        const formattedTotal =
          typeof totalAmount === "number"
            ? CurrencySymbols(
                Number(totalAmount).toFixed(FractionDigits),
                { CurrencySymbol },
                FractionDigits
              )
            : "N/A";
        return (
          <Box sx={{ textAlign: "right", fontWeight: "bold", padding: "8px" }}>
            Total: {formattedTotal}
          </Box>
        );
      },
    },
    {
      header: "Gross Margin",
      accessorKey: "GrossMargin",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => {
        const grossMargin = row?.original?.GrossMargin;
        if (grossMargin == "0.00" || grossMargin == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(grossMargin),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
      AggregatedCell: ({ cell, row }) => {
        const aggregatedValue = cell.getValue();
        const isItemName = row.depth === 0; // Adjust based on your table's grouping structure

        const formattedValue =
          typeof aggregatedValue === "number" && isItemName
            ? CurrencySymbols(
                Number(aggregatedValue),
                { CurrencySymbol },
                FractionDigits
              )
            : "";

        return isItemName ? (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total :
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {formattedValue}
            </Box>
          </>
        ) : null;
      },
    },
    {
      header: "Gross Margin %",
      accessorKey: "GrossMarginPercent",
      filterFn: "contains",
      size: "110",
      AggregatedCell: ({ cell, row }) => {
        const aggregatedValue = cell.getValue();
        const isItemName = row.depth === 0; // Adjust based on your table's grouping structure

        const formattedValue =
          typeof aggregatedValue === "number" && isItemName
            ? CurrencySymbols(
                Number(aggregatedValue),
                { CurrencySymbol },
                FractionDigits
              )
            : "";

        return isItemName ? (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total :
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {formattedValue}
            </Box>
          </>
        ) : null;
      },
    },
    {
      header: "Columns Groupby",
      accessorKey: "ColumnsBy",
    },
  ]);

  const Classiccolumns = [
    {
      title: "Product/Service",
      field: "Itemname",
      headerFilter: "input",
      defaultVisible: true,
    },

    {
      title: "Quantity",
      field: "Quantity",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      // frozen: true,
    },
    {
      title: "Amount",
      field: "Amount",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "% of Sale",
      field: "PercentOfSale",
      headerFilter: "input",
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == null || value == undefined || value == "") {
          return "0.000%";
        }
        // Convert to number and format with 3 decimal places
        const numValue = parseFloat(value);
        return isNaN(numValue) ? "0.000%" : numValue.toFixed(3) + "%";
      },
      bottomCalc: (values) => {
        const sum = values.reduce((a, b) => a + (parseFloat(b) || 0), 0);
        return sum.toFixed(3) + "%"; // 3 decimal places for sum too
      },
      bottomCalcFormatter: function (cell) {
        const value = cell.getValue();
        return `<strong>${value}</strong>`; // Keep bold for summary row
      },
    },

    {
      title: "AVG Price",
      field: "AvgPrice",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "COGS",
      field: "COGS",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Gross Margin",
      field: "GrossMargin",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Gross Margin %",
      field: "GrossMarginPercent",
      headerFilter: "input",
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == null || value == undefined || value == "") {
          return "0.000%";
        }
        // Convert to number and format with 3 decimal places
        const numValue = parseFloat(value);
        return isNaN(numValue) ? "0.000%" : numValue.toFixed(3) + "%";
      },
      bottomCalc: (values) => {
        const sum = values.reduce((a, b) => a + (parseFloat(b) || 0), 0);
        return sum.toFixed(3) + "%"; // 3 decimal places for sum too
      },
      bottomCalcFormatter: function (cell) {
        const value = cell.getValue();
        return `<strong>${value}</strong>`; // Keep bold for summary row
      },
    },

    {
      title: "Columns Groupby",
      field: "ColumnsBy",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },
  ];

  // const columnsGrouping = selectedColumnsBy === 1 ? ["Itemname"] : ["Itemname","ColumnsBy"];

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Open Purchase Order List</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Sales by Product/Service Summary
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3 ">
              <label className="col-form-label col-md-12 form-label p-lg-medium                                            ">
                Report period
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={reportdropdown}
                  defaultValue={selectReport}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  name="Reportperiod"
                  id="Reportperiod"
                  onChange={(event) => {
                    handleDropdownChange(event);
                  }}
                  value={reportdropdown.find(
                    (el) => el?.value === selectReport
                  )}
                  className="custom-search-select"
                ></Select>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-2 ">
              <label className="col-form-label col-md-12 form-label p-lg-medium                                            ">
                Display columns by
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={columnsByOptions}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  onChange={(event) => {
                    setSelectedColumnBy(event?.value);
                  }}
                  value={columnsByOptions.find(
                    (el) => el.value === selectedColumnsBy
                  )}
                  className="custom-search-select"
                ></Select>
              </div>
            </div>
            <div className="col-sm-2">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Locations
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={locationDropdownOption}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  // isClearable={true}
                  name="location"
                  id="location"
                  value={locationDropdownOption.find(
                    (e) => e.value === selectedlocationid
                  )}
                  onChange={(event) => {
                    handleLocationDropdownChange(event);
                  }}
                  className="custom-search-select"
                ></Select>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="p">SonarPos</h6>
                    <p className="fw-bold p-regular">
                      Sales by Product/Service Summary
                    </p>
                    <div className="row mb-2">
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />

                <div>
                  {ReportViewPermission == true ? (
                    <button
                      className="btn btn-secondary"
                      onClick={() => setClassicView(!classicView)}
                    >
                      {" "}
                      {classicView ? "ClassicView" : "Morden View"}
                    </button>
                  ) : (
                    <></>
                  )}
                  {classicView ? (
                    <CommonTabular
                      Data={responseData}
                      columns={Classiccolumns}
                      Groupvalue={["Itemname"]}
                      Reportname={"Sales By Product Service Summary"}
                      frozenRowvalue={0}
                      layout={"fitDataFill"}
                      Onrefresh={() => apicall()}
                    />
                  ) : (
                    <CommonMatrialReactTable
                      MainHeading="Sonar POS"
                      ReportHeading="Sales By Product Service Summary"
                      enableStickyHeader
                      columns={columns}
                      data={responseData}
                      startdate={startdate}
                      enddate={enddate}
                      columnGrouping={["Itemname", "ColumnsBy"]}
                      enableExpandAll={true}
                      enableExpanding={true}
                      expanded={true}
                      columnsVisibility={{}}
                      enableRowSelection={false}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SalesbyProductServiceSummary;
